import React, { Component } from "react";
import Hero from './../../components/hero';
import { Link } from "react-router-dom";
import  './../../utils/analytics';
import  {Colors} from './../../utils/variables';
import ScrollFadeIn from './../../components/scrollFadeIn';

export default class extends Component {
  componentDidMount = ()=>{
    window.scrollTo(0, 0)
  }
  render() {
    return (
		<div className="light-grey-background" style={{backgroundColor:Colors.primaryDark}}>
      <div>
        <Hero
          title={'Forms & Documents'}
          backgroundImage={'/images/friends.jpg'}
          height={'threequarter'} /*full, half,threequarter*/
          tint={''}
        />
      </div>
      <ScrollFadeIn>
        <div className="medium-max-width-container lip" style={{paddingBottopm:'8vh'}}>
          <div className="row sponsor-row">
            <div className="small-12 medium-4 tiny-padding">
              <div className="card centered-text"  style={{ backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
                <a target="_blank" href="./pdfs/photo-release.pdf" style={{textDecoration:'none'}}><h2 className="white large-padding" style={{paddingLeft:0, paddingRight:0}}>{'Photo Release'}</h2></a>
              </div>
            </div>
            <div className="small-12 medium-4 tiny-padding">
              <div className="card centered-text"  style={{ backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
                <a target="_blank" href="./pdfs/health-form.pdf" style={{textDecoration:'none'}}><h2 className="white large-padding" style={{paddingLeft:0, paddingRight:0}}>{'Health Form'}</h2></a>
              </div>
            </div>
            <div className="small-12 medium-4 tiny-padding">
              <div className="card centered-text"  style={{ backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
                <a target="_blank" href="./pdfs/waiver.pdf" style={{textDecoration:'none'}}><h2 className="white large-padding" style={{paddingLeft:0, paddingRight:0}}>{'Waiver'}</h2></a>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="card centered-text"  style={{ backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
                <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdwq-mYT6o7s3e6ROvNikCe0h66DaB5OdGAltW17yIIuA6U6A/viewform?usp=sf_link" style={{textDecoration:'none'}}><h2 className="white large-padding" style={{paddingLeft:0, paddingRight:0}}>{'Ride Guide Volunteer Application'}</h2></a>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="card centered-text"  style={{ backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
                <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfCswZWdzCM5mWN7EnbtJ0IYpnYYbXlTWmKTPXzIUG45k86bA/viewform?usp=sf_link" style={{textDecoration:'none'}}><h2 className="white large-padding" style={{paddingLeft:0, paddingRight:0}}>{'Event Volunteer Application'}</h2></a>
              </div>
            </div>
          </div>
        </div>
      </ScrollFadeIn>
    </div>
    );
  }
}
